import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import {
  getCookieConsent,
  hasStoredCookieConsent,
  US_COOKIE_BANNER_STATES,
  CookieConsentPreferences,
} from '@/lib/utils/cookie-consent';
import { useCustomerLocation } from '@/lib/geolocation/CustomerLocationContext';
import CookieBanner from './CookieBanner';

/** Stores whose every visitor is asked before optional cookies are set. */
const OPT_IN_STORES = [
  'reebelo-uk',
  'reebelo-fr',
  'reebelo-de',
  'reebelo-es',
  'reebelo-it',
  'reebelo-se',
  'reebelo-ie',
  'reebelo-nl',
  'reebelo-at',
  'reebelo-be',
  'reebelo-pt',
  'reebelo-fi',
  'reebelo-dev',
];

export default function CookieConsentGate(): JSX.Element | null {
  const router = useRouter();
  const { country, region } = useCustomerLocation();
  const [consent, setConsent] = useState<CookieConsentPreferences | null>(null);
  const [hydrated, setHydrated] = useState(false);
  const [shouldShowBanner, setShouldShowBanner] = useState(false);

  useEffect(() => {
    setHydrated(true);
  }, []);

  useEffect(() => {
    const store = process.env.NEXT_PUBLIC_STORE ?? '';
    const onSettingsPage = router.asPath.includes('cookie-settings');
    // The US is opt-out, so consent already counts as given: the banner is
    // only shown, to visitors from the listed states, until they choose.
    const isUsBannerVisitor =
      store === 'reebelo-us' &&
      country === 'US' &&
      region !== null &&
      US_COOKIE_BANNER_STATES.includes(region);

    if (isUsBannerVisitor) {
      setConsent(null);
      setShouldShowBanner(!hasStoredCookieConsent() && !onSettingsPage);

      return;
    }

    setConsent(getCookieConsent());
    setShouldShowBanner(OPT_IN_STORES.includes(store) && !onSettingsPage);
  }, [router.asPath, country, region]);

  if (!hydrated) {
    return null;
  }

  if (consent === null && shouldShowBanner) {
    return <CookieBanner onConsentChange={() => window.location.reload()} />;
  }

  return null;
}
